import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Wrap admin sub-routes that require super_admin. Non-super users are
 * redirected back to the dashboard.
 */
export default function RequireSuperAdmin({ children }) {
  const { user, checked } = useAuth();
  if (!checked) return null;
  if (!user || user === false) return <Navigate to="/admin/login" replace />;
  if (user.role !== "super_admin") return <Navigate to="/admin" replace />;
  return children;
}
